const data = [
    {
      id: 1,
      image: "images/Wordpress.png",
      title: "Wordpress Design",
      desc: "Theme Customization, Responsive Design, Plugin Integration, Content Management, SEO Optimization, Troubleshooting & Maintenance & Graphic Integration. ",
    },
   {
    id: 2,
    image: "images/digital.png",
    title: "Digital Marketing",
   },
   {
   id: 3,
   image: "images/seo.png",
   title: "SEO and Keyword Research",
   },
   {
    id: 4,
    image: "images/smo.png",
    title: "SMO",
  },
  {
    id: 5,
    image: "images/faceads.png",
    title: "Facebook & Instagram Ads",
  },
  {
    id: 6,
    image: "images/googleads.png",
    title: "Google Ads",
  },
  {
    id: 7,
    image: "images/Ui.png",
    title: "UI Design",
  },
    {
      id: 8,
      image: "images/infographic.png",
      title: "Infographic ",
    },
    {
      id: 9,
      image: "images/logo.png",
      title: "Logo Design",
    },
      {
        id: 10,
        image: "images/photoed.png",
        title: "Video & Photo Editing",
      },
     
  ]
  export default data